import React from 'react';
import FeatureButton from '@medflex/components/stories/FeatureButton';
import Modal from '@medflex/components/stories/Modal';
import { IconAnnouncement, IconUser, IconUserGroup } from '@medflex/components/stories/Icons';
import { useTranslation } from 'react-i18next';
import Badge, { KINDS } from '@medflex/components/stories/Badge';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import useFeatures from '../hooks/useFeatures';
import { STATUS } from '../store/models/subscription';
import useModal from '../hooks/useModal';
import useSubscription from '../hooks/useSubscription';
import { MODALS } from '../hooks/useIsModal';

const NewMessageSwitchModule = () => {
  const { close, open } = useModal();
  const { t } = useTranslation('messenger');
  const [multicastFeature] = useFeatures([FEATURE_KEYS.MULTICAST_MESSAGE]);
  const { status: subscriptionStatus } = useSubscription();

  const handleContactChat = () => {
    open({ modal: MODALS.contactSearch });
  };
  const handleSessionChat = () => {
    open({ modal: MODALS.sessionChatSearch });
  };
  const handleMulticast = () => {
    if (multicastFeature && multicastFeature.active) {
      open({ modal: MODALS.multicast });
      return;
    }

    open({ modal: MODALS.featureUpgradeMulticast });
  };
  const handleClose = () => close({ modal: MODALS.newMessage });

  return (
    <Modal
      title={t('NewMessageSwitchModule.title')}
      showCloseButton
      onClickCloseButton={handleClose}
      onClickOutside={handleClose}
    >
      {subscriptionStatus === STATUS.LOADED && (
        <div data-component="NewMessageSwitchModule" className="flex flex-col">
          <FeatureButton
            icon={<IconUser size="8" />}
            title={t('NewMessageSwitchModule.contactChat')}
            onClick={handleContactChat}
            className="mb-4"
          />
          <FeatureButton
            icon={<IconUserGroup size="8" />}
            title={t('NewMessageSwitchModule.sessionChat')}
            onClick={handleSessionChat}
            className="mb-4"
          />
          <FeatureButton
            icon={<IconAnnouncement size="8" />}
            title={t('NewMessageSwitchModule.multicast')}
            subtitle={t('NewMessageSwitchModule.multicastSubTitle')}
            onClick={handleMulticast}
            badge={
              multicastFeature &&
              !multicastFeature.active && (
                <Badge kind={KINDS.SIGNAL}>{t('NewMessageSwitchModule.upgrade')}</Badge>
              )
            }
          />
        </div>
      )}
    </Modal>
  );
};

export default NewMessageSwitchModule;
